module.exports = __webpack_public_path__ + "static/media/multiple-choice-list.43989ab6.svg";